import { MsaKey } from "./key";
import { SimpleQueryOptions, useBaseQuery } from "../baseQuery";
import { WakenMsaRequest, WakenMssResponse } from "@maven-rest/orchestra/Msa.dto";
import { MsaUrl } from "@maven-rest/orchestra/Msa.url";

export function useWakenQuery(options?: SimpleQueryOptions<WakenMssResponse, WakenMsaRequest>) {
  return useBaseQuery({
    queryKey: [MsaKey.Waken],
    fnOption: { host: process.env.REACT_APP_ORCHESTRA_BE_URL, url: MsaUrl.waken },
    ...options,
  });
}
